import { decodeJwt } from 'jose'

export const isJwtExpired = (token?: string): boolean => {
  if (!token) {
    return true
  }

  try {
    const decodedToken = decodeJwt(token)
    if (!decodedToken?.exp) {
      return true
    }

    return decodedToken.exp <= Date.now() / 1000
  } catch {
    return true
  }
}
